// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-extraneous-class
class Validator {
  static isEmail(text: string): boolean {
    const expression: RegExp =
      /^([a-zA-Z0-9+_-]+)(\.[a-zA-Z0-9+_-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/

    return expression.test(text)
  }

  static isPassword(text: string): boolean {
    const expression: RegExp =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,}$/

    return expression.test(text)
  }

  static compareEmailPassword(
    email: string,
    pass: string
  ): { status: boolean; error: string } {
    const subEmail = email.substring(0, email.indexOf('@'))
    if (pass !== '' && email !== '' && subEmail === pass) {
      return {
        status: false,
        error: 'ログインIDと同様の文字列は利用できません'
      }
    }
    return {
      status: true,
      error: ''
    }
  }

  static checkPasswordByFunc(
    email: string,
    pass: string
  ): { status: boolean; error: string } {
    const subEmail = email.substring(0, email.indexOf('@'))
    let isEmailIncludePassword = false

    if (pass !== '' && email !== '' && subEmail === pass) {
      return {
        status: false,
        error: 'ログインIDと同様の文字列は利用できません'
      }
    }

    if (pass !== '' && pass.trim().length < 8) {
      return {
        status: false,
        error: '正しいパスワードの形式で入力してください'
      }
    }

    for (let index = 0; index <= pass.length - 3; index++) {
      if (pass[index] === pass[index + 1] && pass[index] === pass[index + 2]) {
        isEmailIncludePassword = true
        return {
          status: false,
          error: '同じ文字を3文字連続で利用できません'
        }
      }
      continue
    }
    // check if string include 3/4 type number, capital letter, normal letter, special letter
    const expressionCondition: RegExp =
      /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*([^\w\s]|[_]))|(?=.*[a-z])(?=.*[A-Z])(?=.*([^\w\s]|[_]))).{8,}$/

    if (!isEmailIncludePassword && expressionCondition.test(pass)) {
      return {
        status: true,
        error: ''
      }
    } else {
      return {
        status: false,
        error:
          '「大文字・小文字・数字・記号」のうち3種類以上組み合わせてください'
      }
    }
  }

  static isValidTel(text: string): boolean {
    const fixedLengthPhone: RegExp = /^\d{10,11}$/
    return fixedLengthPhone.test(text)
  }

  static isZipCode(text: string): boolean {
    const expression: RegExp = /^\d{3}-?\d{4}$/
    return expression.test(text)
  }
}

export default Validator
